import { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import MobileTabs from "./MobileTabs";
import AssistantProvider from "../assistant/AssistantProvider";
import AssistantPanel from "../assistant/AssistantPanel";
import { LightArc, dayFraction } from "../LightArc";

export default function AppShell() {
  const [fraction, setFraction] = useState(() => dayFraction());

  useEffect(() => {
    const t = setInterval(() => setFraction(dayFraction()), 60000);
    return () => clearInterval(t);
  }, []);

  return (
    <AssistantProvider>
      <div className="min-h-screen" data-testid="app-shell">
        <Sidebar fraction={fraction} />

        {/* Mobile top bar */}
        <div className="md:hidden bg-paper/90 backdrop-blur-xl sticky top-0 z-50">
          <div className="h-14 px-5 flex items-center">
            <Link to="/home" className="flex items-center gap-2" data-testid="mobile-brand">
              <img src="/brand/symbol-color.svg" alt="" className="h-5 w-auto" />
              <span className="font-display font-medium text-xl tracking-tight text-ink">wandr</span>
            </Link>
          </div>
          <LightArc fraction={fraction} />
        </div>

        <div className="md:pl-64">
          <Outlet />
        </div>

        <MobileTabs />
        <AssistantPanel />
      </div>
    </AssistantProvider>
  );
}
